import { styled } from '@mui/material/styles';

export const StyledHeader = styled('div')(() => ({}));

// Use transient prop $dividers to avoid passing to DOM
export const StyledContent = styled('div')(({ theme, $dividers }) => ({
  flex: '1 1 auto',
  ...(!!$dividers && {
    borderTop: `1px solid ${theme.color?.border || '#CCCCCC'}`
  })
}));

export const StyledContainer = styled('div')(({ theme, spacing, $disableGutters, $margin }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(0, spacing),
  ...($disableGutters && {
    padding: 0,
    [`& ${StyledHeader}`]: {
      paddingLeft: theme.spacing(spacing)
    }
  }),
  [`& ${StyledContent}`]: {
    flex: '1 1 auto',
    ...($margin === 'normal' && {
      padding: `${theme.spacing(spacing)} 0`
    })
  }
}));
